import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography } from '@mui/material';
import {
  PriceFilterContainer,
  PriceFilterLabel,
  CheckboxGroup,
} from './PriceCheckboxFilter.styled';

const PriceCheckboxFilter = ({ value, onChange }) => {
  const priceOptions = [
    { value: 'low', label: 'Low', description: 'Under $100' },
    { value: 'medium', label: 'Medium', description: '$100 – $500' },
    { value: 'high', label: 'High', description: '$500+' },
  ];

  const handleCheckboxChange = (optionValue) => {
    const newValue = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  return (
    <PriceFilterContainer>
      <PriceFilterLabel variant="subtitle1" component="label">
        Price Range
      </PriceFilterLabel>
      <CheckboxGroup>
        {priceOptions.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                checked={value.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
                color="primary"
              />
            }
            label={
              <Box>
                <Typography variant="body2" fontWeight={500}>
                  {option.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {option.description}
                </Typography>
              </Box>
            }
            sx={{
              margin: 0,
              '& .MuiFormControlLabel-label': {
                marginLeft: 1,
              },
            }}
          />
        ))}
      </CheckboxGroup>
    </PriceFilterContainer>
  );
};

export default PriceCheckboxFilter;
